const faForwardFast = {
  prefix: 'fal',
  iconName: 'forward-fast',
  icon: [
    512,
    512,
    [9197, 'fast-forward'],
    'f050',
    'M496 480c8.8 0 16-7.2 16-16l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 165.9-203.2-174.1c-9.5-8.1-22.8-10-34.2-4.8S224 51.5 224 64L224 186.4 52.8 39.7c-9.5-8.1-22.8-10-34.2-4.8S0 51.5 0 64L0 448c0 12.5 7.3 23.8 18.6 29.1s24.7 3.4 34.2-4.8L224 325.6 224 448c0 12.5 7.3 23.8 18.6 29.1s24.7 3.4 34.2-4.8L480 298.1 480 464c0 8.8 7.2 16 16 16zM224 283.4L32 448 32 64 224 228.6 224 283.4zM256 448l0-384 224 192-224 192z',
  ],
};
export default faForwardFast;
